import Pill from './Pill';
import './pill.scss';

export default Pill;
